import _extends from '../../node_modules/@babel/runtime-corejs3/helpers/esm/extends.js';
import React, { useRef, useMemo } from 'react';
import { listToMap } from '@togglecorp/fujs';
import useNumericChartData from '../../hooks/useNumericChartData.js';
import { extractBarChartProps } from '../../utils/chart.js';
import BarChartContainer from '../BarChartContainer/index.js';
import BarList from '../BarList/index.js';
import ChartAxes from '../ChartAxes/index.js';

function NumericBarChart(props) {
  const {
    containerProps,
    commonProps: {
      data,
      yValueKeys,
      colorSelector
    },
    chartDataProps,
    chartAxesProps,
    barListProps: barGroupProps
  } = extractBarChartProps(props);
  const chartContainerRef = useRef(null);
  const chartData = useNumericChartData(data, {
    containerRef: chartContainerRef,
    ...chartDataProps
  });
  const colorMap = useMemo(() => listToMap(yValueKeys, key => key, colorSelector), [colorSelector, yValueKeys]);
  const xTickWidth = chartData.dataAreaSize.width / chartData.numXAxisTicks;
  return /*#__PURE__*/React.createElement(BarChartContainer, _extends({
    containerRef: chartContainerRef
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, containerProps), /*#__PURE__*/React.createElement(ChartAxes, _extends({
    chartData: chartData
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, chartAxesProps)), /*#__PURE__*/React.createElement(BarList, _extends({
    chartData: chartData,
    xTickWidth: xTickWidth,
    colorMap: colorMap
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, barGroupProps)));
}

export { NumericBarChart as default };
//# sourceMappingURL=index.js.map
